export default {
  data: () => ({
    form: {}
  }),

  methods: {
    isManuallyType(v = this.form.type) {
      return v === 'E';
    }
  }
};
